import { toJS } from 'mobx';
import convertUnicode from '~/common/utils/convertUnicode.js';

export function mapData(obj, data) {
    // convert the observable to json
    let newObj = toJS(obj);
    Object.keys(newObj).map((key) => {
        // translate strings
        if (typeof data[key] == "string") {
            if (typeof data[key] === typeof newObj[key]) {
                // if we are expecting the data, use it else lose it
                return newObj[key] ? newObj[key] = convertUnicode(data[key]) : null;
            } else {
                return data[key] ? data[key] = convertUnicode(data[key]) : null;
                console.log('Invalid JSON passed', data[key], key);
            }
        }
        else {
            // sanitize the data, should be a string
            if (typeof data[key] === typeof newObj[key]) {
                // if we are expecting the data, use it else lose it
                return newObj[key] ? newObj[key] = data[key] : null;
            } else {
                console.log('Invalid JSON passed', data[key], key);
            }
        }
    });

    return newObj;
}
